export default "__VITE_ASSET__LKto0Rd3__"